import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CoachMarkerSetJourneyStatusesByClientResponse } from '../../Models/Models/CoachMarkers/CoachMarkerSetJourneyStatusesByClientResponse';
import { CoachMarkerSetJourney } from '../../Models/Models/CoachMarkers/CoachMarkerSetJourney';

declare var IS_RUNNING_IN_APP_POOL;

export class CoachMarkerSetJourneyStateForClientClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<CoachMarkerSetJourneyStatusesByClientResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/CoachMarkers/CoachMarkerSetJourneyStateForClient/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<CoachMarkerSetJourneyStatusesByClientResponse, any>(url, data);
  }
  public put(requestBody: CoachMarkerSetJourney): Promise<CoachMarkerSetJourneyStatusesByClientResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/CoachMarkers/CoachMarkerSetJourneyStateForClient/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { requestBody: requestBody }

    return AjaxWrapper.put<CoachMarkerSetJourneyStatusesByClientResponse, any>(url, data);
  }
}

